var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToDoListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.027,
    height: 26.872,
    viewBox: "0 0 18.027 26.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ToDoListIcon",
    transform: "translate(-292.745 -523.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M737.038,1117.658v-.085a1.371,1.371,0,1,0-2.741,0v.085",
    transform: "translate(-433.92 -592.438)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M732.755,1118.044v2.891a.485.485,0,0,0,.493.493h.192a.507.507,0,0,0,.493-.429v-.064a1.729,1.729,0,0,1,3.427,0V1121a.495.495,0,0,0,.985-.064v-2.891a.384.384,0,0,0-.386-.386H733.1A.377.377,0,0,0,732.755,1118.044Z",
    transform: "translate(-433.92 -592.438)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M732.755,1118.836h-4.241a1.343,1.343,0,0,0-1.349,1.349v20.54a1.343,1.343,0,0,0,1.349,1.349h14.328a1.344,1.344,0,0,0,1.35-1.349v-20.54a1.344,1.344,0,0,0-1.35-1.349h-4.455",
    transform: "translate(-433.92 -592.438)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M732.3,1120.807h-3.148v19.254h10.088l2.934-2.934v-16.32h-3.127",
    transform: "translate(-433.92 -592.438)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M734.146,1129.009l-1.564,1.671-.771-.771",
    transform: "translate(-433.92 -592.438)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    y1: 1.863,
    x2: 1.863,
    transform: "translate(297.979 531.731)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    x1: 1.863,
    y1: 1.863,
    transform: "translate(297.979 531.731)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    y1: 1.885,
    x2: 1.863,
    transform: "translate(297.979 541.39)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    x1: 1.863,
    y1: 1.885,
    transform: "translate(297.979 541.39)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    "data-name": "Line 79",
    x2: 5.44,
    transform: "translate(301.19 533.594)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_80",
    "data-name": "Line 80",
    x2: 5.44,
    transform: "translate(301.19 538.349)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M738.623,1138.861v-2.377H741",
    transform: "translate(-433.92 -592.438)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToDoListIcon);
export default __webpack_public_path__ + "static/media/ToDoListIcon.72819793fcdf4bb8409da0ef2f35c47d.svg";
export { ForwardRef as ReactComponent };